import { createAction, createReducer } from 'redux-act';
import { API_INSTANCE } from '../../utils/service-http';
import { getAppLocale } from '../../utils/app-locale';
import { api_base_url } from '../../constants';
import { appConfiguration } from '../../utils/app-starter';

// For this call, we will need a token, we need the result for only the last module selected.
let currentModuleActionToken = 0;

const DEFAULT_MODULE_ACTIONS = {
  isLoading: false
}

const getModuleActionsStarted = createAction('GET_MODULE_ACTIONS_STARTED');
const getModuleActionsSuccess = createAction('GET_MODULE_ACTIONS_SUCCESS');
const getModuleActionsFailed = createAction('GET_MODULE_ACTIONS_FAILED');

export const moduleActionsReducer = createReducer(function (on, off) {
  on(getModuleActionsStarted, (state, payload) => {
    return {
      isLoading: true
    };
  });
  on(getModuleActionsSuccess, (state, payload) => {
    return {
      isLoading: false
    };
  });
  on(getModuleActionsFailed, (state, payload) => {
    return {
      isLoading: false
    };
  });
}, DEFAULT_MODULE_ACTIONS);

const getToken = () => {
  if (currentModuleActionToken === 200000000) {
    currentModuleActionToken = 0;
  }

  return ++currentModuleActionToken;
}


export const getModuleActions = (configurationId, moduleSlot, moduleType, updateSlot, specificIslandSlot, specificLocalRack = null) => {
  return async dispatch => {
    dispatch(getModuleActionsStarted());
    let actionToken = getToken();
    const params = {};
    if (specificIslandSlot >= 1) {
      params.island = specificIslandSlot;
    }
    if (specificLocalRack >= 1) {
      params.localRack = specificLocalRack;
    }
    let paramsStr = Object.entries(params).map(([key, value]) => `&${key}=${value}`).join('');
    paramsStr += `&updateSlot=${updateSlot}`
    const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';

    return API_INSTANCE.post(`${api_base_url}/configurations/${configurationId}/module-actions?locale=${getAppLocale()}${paramsStr}${mainOverrideString}`,
      {
        moduleSlot,
        moduleType,
        distributorUnscoping: appConfiguration.distributorUnscoping
      })
      .then((result) => {
        // If not other module was selected while waiting for the result.
        if (actionToken === currentModuleActionToken) {
          dispatch(getModuleActionsSuccess());
          return result.data.payload
        }

        return { cancelled: true };
      })
      .catch((error) => {
        dispatch(getModuleActionsFailed([]));
        throw error;
      })
  };
}
